export default {
      id: "common__remove_sm-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__remove_sm",
      toString: function () {
        return this.url;
      }
    }